import React, { useEffect, useState } from "react";

import Container from "./container";
import Input from "./input";

import { FormContext, iControlProps } from "../types";

type uuidProps = iControlProps & {
    context: FormContext;
    name: string;
    error: string;
};

const UUID = (props: uuidProps) => {
    const { context, name } = props;
    const [error, setError] = useState(props.error || "");

    useEffect(() => {
        if (error !== "") {
            context.setValue(name, "");
            setError("");
        }
    }, [context, error, name]);

    return (
        <Container {...{ ...props, error: error }} size="large">
            <Input
                {...{
                    ...props,
                    type: "text",
                    error: error
                }}
                readOnly={true}
            />
        </Container>
    );
};

export default UUID;
